import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { API_UPLOAD_URL } from "./config";

const THEME_ORANGE = "#F07828";
const THEME_ORANGE_2 = "#ed7f35ff";
const BG = "#F2F2F2";
const BORDER = "rgba(25,118,210,0.20)";
const BORDER_SOFT = "rgba(25,118,210,0.10)";

const previewSurface = {
  borderRadius: 2,
  border: `1px solid ${BORDER}`,
  overflow: "hidden",
  background: "#fff",
};

const headerBarSx = {
  px: 2,
  py: 1.5,
  background: `linear-gradient(90deg, ${THEME_ORANGE} 0%, ${THEME_ORANGE_2} 100%)`,
  color: "white",
};

const normalizeHtmlImageSrc = (html) => {
  if (!html) return html;

  return String(html).replace(/src="([^"]+)"/g, (match, src) => {
    if (!src) return match;

    const value = String(src).trim();

    if (value.startsWith("data:")) return match;
    if (/^https?:\/\//i.test(value)) return match;

    const clean = value.replace(/^\/+/, "");

    if (clean.startsWith("uploads/")) {
      return `src="${API_UPLOAD_URL}/${clean}"`;
    }

    return `src="${API_UPLOAD_URL}/uploads/${clean}"`;
  });
};

export default function IdCardPreview({
  frontHtml,
  backHtml,
  title = "Preview",
  orientation = "PORTRAIT",
  cardWidth,
  cardHeight,
}) {
  const safeFrontHtml = normalizeHtmlImageSrc(frontHtml);
  const safeBackHtml = normalizeHtmlImageSrc(backHtml);

  const finalOrientation = String(orientation || "PORTRAIT").toUpperCase();
  const isPortrait = finalOrientation === "PORTRAIT";

  return (
    <Paper elevation={0} sx={{ ...previewSurface, background: BG }}>
      <Box sx={headerBarSx}>
        <Typography sx={{ fontWeight: 900, fontSize: "1rem" }}>{title}</Typography>
      </Box>

      <Box sx={{ p: 2, backgroundColor: BG }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <Paper
            elevation={0}
            sx={{
              ...previewSurface,
              flex: "0 0 auto",
              width: "fit-content",
              maxWidth: "100%",
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1,
                borderBottom: `1px solid ${BORDER_SOFT}`,
                background: "rgba(25,118,210,0.04)",
              }}
            >
              <Typography sx={{ fontWeight: 900, color: "rgba(25,118,210,0.95)" }}>
                Front Side ({finalOrientation})
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                background: "#fafafa",
                overflow: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{
                  transformOrigin: "top center",
                }}
                dangerouslySetInnerHTML={{
                  __html: safeFrontHtml || "<div>No front preview</div>",
                }}
              />
            </Box>
          </Paper>

          <Paper
            elevation={0}
            sx={{
              ...previewSurface,
              flex: "0 0 auto",
              width: "fit-content",
              maxWidth: "100%",
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1,
                borderBottom: `1px solid ${BORDER_SOFT}`,
                background: "rgba(25,118,210,0.04)",
              }}
            >
              <Typography sx={{ fontWeight: 900, color: "rgba(25,118,210,0.95)" }}>
                Back Side ({finalOrientation})
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                background: "#fafafa",
                overflow: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{
                  transformOrigin: "top center",
                }}
                dangerouslySetInnerHTML={{
                  __html: safeBackHtml || "<div>No back preview</div>",
                }}
              />
            </Box>
          </Paper>
        </Box>
      </Box>
    </Paper>
  );
}